import React from 'react';
import { useSelector } from 'react-redux';
import { RecordInformedConsentForm } from './RecordInformedConsentForm';
import { useFeatureFlagContext } from '@/context/featureFlagContext';

export const RecordInformedConsentDialog = () => {
	const open = useSelector((state) => state.dialog.open?.recordInformedConsent);

	const { getFeatureFlags } = useFeatureFlagContext();
	const informedConsentEnabled = Boolean(getFeatureFlags('informedConsent')?.active);

	if (!open || !informedConsentEnabled) return <></>;
	return <RecordInformedConsentForm />;
};
